export default {
  GET_EDITOR_COMPONENTS_REQUEST: '@@editor/GET_EDITOR_COMPONENTS_REQUEST',
  GET_EDITOR_COMPONENTS_SUCCESS: '@@editor/GET_EDITOR_COMPONENTS_SUCCESS',
  GET_EDITOR_COMPONENTS_ERROR: '@@editor/GET_EDITOR_COMPONENTS_ERROR',

  GET_EDITOR_ROWS_REQUEST: '@@editor/GET_EDITOR_ROWS_REQUEST',
  GET_EDITOR_ROWS_SUCCESS: '@@editor/GET_EDITOR_ROWS_SUCCESS',
  GET_EDITOR_ROWS_ERROR: '@@editor/GET_EDITOR_ROWS_ERROR',

  DELETE_EDITOR_ROW_REQUEST: '@@editor/DELETE_EDITOR_ROW_REQUEST',
  DELETE_EDITOR_ROW_SUCCESS: '@@editor/DELETE_EDITOR_ROW_SUCCESS',
  DELETE_EDITOR_ROW_ERROR: '@@editor/DELETE_EDITOR_ROW_ERROR',

  BULK_EDITOR_ROWS_REQUEST: '@@editor/BULK_EDITOR_ROWS_REQUEST',
  BULK_EDITOR_ROWS_SUCCESS: '@@editor/BULK_EDITOR_ROWS_SUCCESS',
  BULK_EDITOR_ROWS_ERROR: '@@editor/BULK_EDITOR_ROWS_ERROR',

  BULK_EDITOR_COLUMNS_REQUEST: '@@editor/BULK_EDITOR_COLUMNS_REQUEST',
  BULK_EDITOR_COLUMNS_SUCCESS: '@@editor/BULK_EDITOR_COLUMNS_SUCCESS',
  BULK_EDITOR_COLUMNS_ERROR: '@@editor/BULK_EDITOR_COLUMNS_ERROR',

  BULK_EDITOR_POSITIONS_REQUEST: '@@editor/BULK_EDITOR_POSITIONS_REQUEST',
  BULK_EDITOR_POSITIONS_SUCCESS: '@@editor/BULK_EDITOR_POSITIONS_SUCCESS',
  BULK_EDITOR_POSITIONS_ERROR: '@@editor/BULK_EDITOR_POSITIONS_ERROR',

  CREATE_EDITOR_COLUMNS_REQUEST: '@@editor/CREATE_EDITOR_COLUMNS_REQUEST',
  CREATE_EDITOR_COLUMNS_SUCCESS: '@@editor/CREATE_EDITOR_COLUMNS_SUCCESS',
  CREATE_EDITOR_COLUMNS_ERROR: '@@editor/CREATE_EDITOR_COLUMNS_ERROR',

  DELETE_EDITOR_CELL_REQUEST: '@@editor/DELETE_EDITOR_CELL_REQUEST',
  DELETE_EDITOR_CELL_SUCCESS: '@@editor/DELETE_EDITOR_CELL_SUCCESS',
  DELETE_EDITOR_CELL_ERROR: '@@editor/DELETE_EDITOR_CELL_ERROR',

  CREATE_EDITOR_ROW_REQUEST: '@@editor/CREATE_EDITOR_ROW_REQUEST',
  CREATE_EDITOR_ROW_SUCCESS: '@@editor/CREATE_EDITOR_ROW_SUCCESS',
  CREATE_EDITOR_ROW_ERROR: '@@editor/CREATE_EDITOR_ROW_ERROR',

  GET_EDITOR_OBJECTS_REQUEST: '@@editor/GET_EDITOR_OBJECTS_REQUEST',
  GET_EDITOR_OBJECTS_SUCCESS: '@@editor/GET_EDITOR_OBJECTS_SUCCESS',
  GET_EDITOR_OBJECTS_ERROR: '@@editor/GET_EDITOR_OBJECTS_ERROR',

  GET_EDITOR_CONTENTS_REQUEST: '@@editor/GET_EDITOR_CONTENTS_REQUEST',
  GET_EDITOR_CONTENTS_SUCCESS: '@@editor/GET_EDITOR_CONTENTS_SUCCESS',
  GET_EDITOR_CONTENTS_ERROR: '@@editor/GET_EDITOR_CONTENTS_ERROR',

  GET_OPERATION_EDITOR_STYLES_REQUEST: '@@editor/GET_OPERATION_EDITOR_STYLES_REQUEST',
  GET_OPERATION_EDITOR_STYLES_SUCCESS: '@@editor/GET_OPERATION_EDITOR_STYLES_SUCCESS',
  GET_OPERATION_EDITOR_STYLES_ERROR: '@@editor/GET_OPERATION_EDITOR_STYLES_ERROR',

  CREATE_OPERATION_EDITOR_STYLE_REQUEST: '@@editor/CREATE_OPERATION_EDITOR_STYLE_REQUEST',
  CREATE_OPERATION_EDITOR_STYLE_SUCCESS: '@@editor/CREATE_OPERATION_EDITOR_STYLE_SUCCESS',
  CREATE_OPERATION_EDITOR_STYLE_ERROR: '@@editor/CREATE_OPERATION_EDITOR_STYLE_ERROR',

  UPDATE_OPERATION_EDITOR_STYLE_REQUEST: '@@editor/UPDATE_OPERATION_EDITOR_STYLE_REQUEST',
  UPDATE_OPERATION_EDITOR_STYLE_SUCCESS: '@@editor/UPDATE_OPERATION_EDITOR_STYLE_SUCCESS',
  UPDATE_OPERATION_EDITOR_STYLE_ERROR: '@@editor/UPDATE_OPERATION_EDITOR_STYLE_ERROR',

  GET_EDITOR_HEADERS_FOOTERS_REQUEST: '@@editor/GET_EDITOR_HEADERS_FOOTERS_REQUEST',
  GET_EDITOR_HEADERS_FOOTERS_SUCCESS: '@@editor/GET_EDITOR_HEADERS_FOOTERS_SUCCESS',
  GET_EDITOR_HEADERS_FOOTERS_ERROR: '@@editor/GET_EDITOR_HEADERS_FOOTERS_ERROR',

  GET_EDITOR_OVERLAYS_REQUEST: '@@editor/GET_EDITOR_OVERLAYS_REQUEST',
  GET_EDITOR_OVERLAYS_SUCCESS: '@@editor/GET_EDITOR_OVERLAYS_SUCCESS',
  GET_EDITOR_OVERLAYS_ERROR: '@@editor/GET_EDITOR_OVERLAYS_ERROR',

  GET_POSITIONS_REQUEST: '@@editor/GET_POSITIONS_REQUEST',
  GET_POSITIONS_SUCCESS: '@@editor/GET_POSITIONS_SUCCESS',
  GET_POSITIONS_ERROR: '@@editor/GET_POSITIONS_ERROR',

  ADD_POSITION_REQUEST: '@@editor/ADD_POSITION_REQUEST',
  ADD_POSITION_SUCCESS: '@@editor/ADD_POSITION_SUCCESS',
  ADD_POSITION_ERROR: '@@editor/ADD_POSITION_ERROR',

  COPY_POSITION_REQUEST: '@@editor/COPY_POSITION_REQUEST',
  COPY_POSITION_SUCCESS: '@@editor/COPY_POSITION_SUCCESS',
  COPY_POSITION_ERROR: '@@editor/COPY_POSITION_ERROR',

  UPDATE_POSITION_REQUEST: '@@editor/UPDATE_POSITION_REQUEST',
  UPDATE_POSITION_SUCCESS: '@@editor/UPDATE_POSITION_SUCCESS',
  UPDATE_POSITION_ERROR: '@@editor/UPDATE_POSITION_ERROR',

  DELETE_POSITION_REQUEST: '@@editor/DELETE_POSITION_REQUEST',
  DELETE_POSITION_SUCCESS: '@@editor/DELETE_POSITION_SUCCESS',
  DELETE_POSITION_ERROR: '@@editor/DELETE_POSITION_ERROR',

  MODIFY_POSITION_ID_REQUEST: '@@editor/MODIFY_POSITION_ID_REQUEST',
  MODIFY_POSITION_ID_SUCCESS: '@@editor/MODIFY_POSITION_ID_SUCCESS',
  MODIFY_POSITION_ID_ERROR: '@@editor/MODIFY_POSITION_ID_ERROR',

  UPDATE_EDITOR_ROW_REQUEST: '@@editor/UPDATE_EDITOR_ROW_REQUEST',
  UPDATE_EDITOR_ROW_SUCCESS: '@@editor/UPDATE_EDITOR_ROW_SUCCESS',
  UPDATE_EDITOR_ROW_ERROR: '@@editor/UPDATE_EDITOR_ROW_ERROR',

  UPDATE_EDITOR_COLUMN_REQUEST: '@@editor/UPDATE_EDITOR_COLUMN_REQUEST',
  UPDATE_EDITOR_COLUMN_SUCCESS: '@@editor/UPDATE_EDITOR_COLUMN_SUCCESS',
  UPDATE_EDITOR_COLUMN_ERROR: '@@editor/UPDATE_EDITOR_COLUMN_ERROR',

  UPDATE_EDITOR_OBJECT_REQUEST: '@@editor/UPDATE_EDITOR_OBJECT_REQUEST',
  UPDATE_EDITOR_OBJECT_SUCCESS: '@@editor/UPDATE_EDITOR_OBJECT_SUCCESS',
  UPDATE_EDITOR_OBJECT_ERROR: '@@editor/UPDATE_EDITOR_OBJECT_ERROR',

  UPDATE_EDITOR_CONTENT_REQUEST: '@@editor/UPDATE_EDITOR_CONTENT_REQUEST',
  UPDATE_EDITOR_CONTENT_SUCCESS: '@@editor/UPDATE_EDITOR_CONTENT_SUCCESS',
  UPDATE_EDITOR_CONTENT_ERROR: '@@editor/UPDATE_EDITOR_CONTENT_ERROR',

  BULK_EDITOR_CONTENTS_REQUEST: '@@editor/BULK_EDITOR_CONTENTS_REQUEST',
  BULK_EDITOR_CONTENTS_SUCCESS: '@@editor/BULK_EDITOR_CONTENTS_SUCCESS',
  BULK_EDITOR_CONTENTS_ERROR: '@@editor/BULK_EDITOR_CONTENTS_ERROR',

  CREATE_EDITOR_CONTENT_REQUEST: '@@editor/CREATE_EDITOR_CONTENT_REQUEST',
  CREATE_EDITOR_CONTENT_SUCCESS: '@@editor/CREATE_EDITOR_CONTENT_SUCCESS',
  CREATE_EDITOR_CONTENT_ERROR: '@@editor/CREATE_EDITOR_CONTENT_ERROR',

  UPDATE_EDITOR_CONTENT_CUSTOMIZATION_REQUEST: '@@editor/UPDATE_EDITOR_CONTENT_CUSTOMIZATION_REQUEST',
  UPDATE_EDITOR_CONTENT_CUSTOMIZATION_SUCCESS: '@@editor/UPDATE_EDITOR_CONTENT_CUSTOMIZATION_SUCCESS',
  UPDATE_EDITOR_CONTENT_CUSTOMIZATION_ERROR: '@@editor/UPDATE_EDITOR_CONTENT_CUSTOMIZATION_ERROR',

  CREATE_LIBRARY_EDITOR_OBJECT_REQUEST: '@@editor/CREATE_LIBRARY_EDITOR_OBJECT_REQUEST',
  CREATE_LIBRARY_EDITOR_OBJECT_SUCCESS: '@@editor/CREATE_LIBRARY_EDITOR_OBJECT_SUCCESS',
  CREATE_LIBRARY_EDITOR_OBJECT_ERROR: '@@editor/CREATE_LIBRARY_EDITOR_OBJECT_ERROR',

  UPDATE_LIBRARY_EDITOR_OBJECT_REQUEST: '@@editor/UPDATE_LIBRARY_EDITOR_OBJECT_REQUEST',
  UPDATE_LIBRARY_EDITOR_OBJECT_SUCCESS: '@@editor/UPDATE_LIBRARY_EDITOR_OBJECT_SUCCESS',
  UPDATE_LIBRARY_EDITOR_OBJECT_ERROR: '@@editor/UPDATE_LIBRARY_EDITOR_OBJECT_ERROR',

  GET_OPERATION_EDITOR_OBJECTS_REQUEST: '@@editor/GET_OPERATION_EDITOR_OBJECTS_REQUEST',
  GET_OPERATION_EDITOR_OBJECTS_SUCCESS: '@@editor/GET_OPERATION_EDITOR_OBJECTS_SUCCESS',
  GET_OPERATION_EDITOR_OBJECTS_ERROR: '@@editor/GET_OPERATION_EDITOR_OBJECTS_ERROR',

  GET_OPERATION_EDITOR_OBJECT_RESULT_REQUEST: '@@editor/GET_OPERATION_EDITOR_OBJECT_RESULT_REQUEST',
  GET_OPERATION_EDITOR_OBJECT_RESULT_SUCCESS: '@@editor/GET_OPERATION_EDITOR_OBJECT_RESULT_SUCCESS',
  GET_OPERATION_EDITOR_OBJECT_RESULT_ERROR: '@@editor/GET_OPERATION_EDITOR_OBJECT_RESULT_ERROR',

  CREATE_MEDIA_STORAGE_ASYNC_REQUEST: '@@editor/CREATE_MEDIA_STORAGE_ASYNC_REQUEST',
  CREATE_MEDIA_STORAGE_ASYNC_SUCCESS: '@@editor/CREATE_MEDIA_STORAGE_ASYNC_SUCCESS',
  CREATE_MEDIA_STORAGE_ASYNC_ERROR: '@@editor/CREATE_MEDIA_STORAGE_ASYNC_ERROR',

  GET_SYSTEM_PAGES_TEMPLATES_REQUEST: '@@editor/GET_SYSTEM_PAGES_TEMPLATES_REQUEST',
  GET_SYSTEM_PAGES_TEMPLATES_SUCCESS: '@@editor/GET_SYSTEM_PAGES_TEMPLATES_SUCCESS',
  GET_SYSTEM_PAGES_TEMPLATES_ERROR: '@@editor/GET_SYSTEM_PAGES_TEMPLATES_ERROR',
};
